import React from "react";
import clsx from "clsx";
import { User } from "../../../../../../../models/Entities";
import { Text } from "@merge-api/merge-javascript-shared";

type NameEmailCellProps = {
  user: User;
};

const NameEmailCell = ({ user }: NameEmailCellProps) => {
  return (
    // Member name and email are user PII and are thus masked at the cell
    <td className="ph-no-capture">
      <div className={clsx("flex flex-col", !user.is_active && "text-gray-40")}>
        <Text variant="h6">{user.name}</Text>
        <Text>{user.email}</Text>
      </div>
    </td>
  );
};

export default NameEmailCell;
